const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const monthName = (monthNumber: number) => {
    return monthNumber > 12
        ? months[11]
        : monthNumber < 1
        ? months[0]
        : months[monthNumber - 1];
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/monthName.ts